import { GROUPS_PATH } from 'cpmWorkspaces/navigation';

module.exports = {
  path: GROUPS_PATH,
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/WorkspaceGroups'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/routes/show/routes/groups/index.js